var DialogView = require('dialogview');


var InvitesDialogView = DialogView.extend({
    el: '#invitesContainer',
    initialize: function (options) {
        _.bindAll(this, 'focusEmail', 'hideError');
        this.afterShow = this.focusEmail;
        this.afterHide = this.hideError;
        DialogView.prototype.initialize.apply(this, arguments);
        
        this.email = $('#invitesEmail');
        this.error = $('#invitesError');
        this.invitesHideBadge = $('#invitesHideBadge');
        
        this.model.bind('change:num_invites', this.renderInvites, this);
        this.model.bind('init', this.init, this);
        this.model.bind('showInvites', this.show, this);
        this.model.bind('hideInvites', this.hide, this);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit #invitesForm': 'submit',
        'change #invitesHideBadge': 'toggleShowBadge'
    }),
    toggleShowBadge: function (e) {
        if (this.model.isInitialized()) {
            var showBadge = this.invitesHideBadge.prop('checked');
            this.model.setPref('hideInviteBadge', !showBadge);
        }
    },
    init: function () {
        this.renderInvites();
    },
    submit: function (e) {
        e.preventDefault();
        if (this.model.featureCheck('invites')) {
            this.model.sendInvite(this.email.val(), _.bind(function callback (response) {
                if (response.success) {
                    this.email.val('');
                    this.model.set({num_invites: response.num_remaining});
                    this.hide();
                } else {
                    var message;
                    switch (response.message) {
                    case 'num_invites':
                        message = 'You’ve run out of invites';
                        break;
                    case 'invalid_email':
                        message = 'Invalid email address, try again';
                        break;
                    case 'empty_email':
                        message = 'Missing email address, try again';
                        break;
                    default:
                        message = 'Error sending invite: ' + response.message;
                        break;
                    }
                    this.showError(message);
                }
            }, this));
        } else {
            this.showError("Invites are disabled");
        }
    },
    renderInvites: function () {
        var showBadge = !this.model.getPref('hideInviteBadge');
        this.invitesHideBadge.prop('checked', showBadge);
    },
    showError: function (message) {
        this.error.text(message).fadeIn('fast');
    },
    focusEmail: function () {
        this.email.focus().select();
    },
    hideError: function () {
        this.error.hide();
    }
});


module.exports = InvitesDialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/invitesdialogview.js
// module id = M5Sr
// module chunks = 1